<template>
  <BlockChapters v-if="chapters.length" :chapters="chapters" />
  <template v-for="cat in others" :key="cat.id">
    <BlockDiscipline :category="cat" :library-book-id="currentContent.id" />
  </template>

  <BlockContentNotAvailable v-if="others.length + chapters.length === 0" />
</template>
<script lang="ts" setup>
import { ContentTypes } from '~/types/adamTypes';
const { categoryManager, currentContent } = inject(INJECT_CATEGORY_PAGE);
const { category } = categoryManager;

const chapters = computed(() => {
  return category.value.children.filter(
    (child) => child.contentType === ContentTypes.Chapter
  );
});

const others = computed<CategorySchema[]>(() => {
  const others = category.value.children.filter(
    (child) =>
      child.contentType !== ContentTypes.Chapter &&
      child.contentType !== ContentTypes.Result &&
      child.contentType !== ContentTypes.DimensionTest
  );
  return others.filter((other) => other.children && other.children.length);
});
</script>
